<script>
import Utils from '../../Utils'
//
const supPourcent = 'span .line .date';
const dark = 'dark';
//
const supPourcentCard = 'span .line.grey .date';
const subPourcentCard = 'span .line:not([grey]) .date';
const darkCard = 'dark';
//
let pourcent = '';
//
export default {
  name: "Card",
  components:{ 
  },
  data(){
    return {
        max: 100,
        value: 0,
        valueTwo: 0, 
        isNegative : false,
        difference:0,
        pourcentYear: 0
    }
  },
  methods : {
    getNegatifOrNot(number){
      this.isNegative = Utils.getFirstLetter(number);
    },  
    getPourcentByYear(){
      let weekNumber = 52;
      let numberOfWeek = Utils.getNumberOfWeek();
      this.pourcentYear = (numberOfWeek/weekNumber)*100;  
    },
    getPourcent(){
      let pourcent = '';
      let dateTarget = null;
      let s= '';

      pourcent = Math.round((parseInt(this.resultOne.split(' ').join(s), 10) / parseInt(this.allNumber.split(' ').join(s), 10))*100);
      this.value = pourcent;
      if(pourcent <= 50){
        dateTarget = this.$el.querySelector(supPourcent);
        dateTarget?dateTarget.classList.add(dark): '';
        dateTarget?dateTarget.style.left = `${pourcent}%`: '';  
       
      } 
    },  
    getPourcentBetween(value,valueTwo){
      let valueTop = value;
      let valueBottom  = valueTwo;
      let result = '';

      if( valueTop >= valueBottom ){
          pourcent = Math.round((valueBottom / valueTop)*100);
          result = valueTop - valueBottom;
          this.difference = `+ ${result}`;
          //
          valueBottom = pourcent;
          valueTop = 100;
          //
          if(pourcent <= 50){   
            this.addClassTo(supPourcentCard);    
          }   
                 
        } else {
          pourcent = Math.round((valueTop / valueBottom)*100);
          result = valueBottom - valueTop;
          this.difference = `- ${result}`;
          //
          valueTop = pourcent;
          valueBottom = 100;
          //
          if(pourcent <= 50){
            this.addClassTo(subPourcentCard);
          }            
      }
      //
      this.value = valueTop;
      this.valueTwo = valueBottom;
      this.getNegatifOrNot(this.difference);
    },  
    addClassTo(target){
      let date = null;
          date = this.$el.querySelector(target);
          date ? date.classList.add(darkCard):'';
          date ? date.style.left = `${pourcent}%`:'';   
    },

  }
}
</script>